import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useRef, useState } from 'react';
import * as jnb from 'react-bootstrap';
import Sweetalert from '../../../CommonUtils/CommonPopupAndAlerts/SweetAlerts';
import { config } from '../../../CommonUtils/CommonUrl/CommonUrls';
import { CommonAxiosPost } from '../../../CommonUtils/CommonAxios/CommonAxios';
import { useSelector } from 'react-redux';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import ApprovalPrintPdf from './ApprovalPrintPdf';
import { useLocation } from 'react-router-dom';
import Header from '../../../Header/Header';
import { CommonPageHeading } from '../../../CommonUtils/CommonHeading/CommonPageHeading';
export default function ApprovalPaymentConfirm() {
    const location = useLocation();
    const data = location?.state
    const [showList, setList] = useState([]);
    const ref = useRef();
    const loginreducer = useSelector((state) => state?.reducers?.loginreducer?.loginDetails?.loginData);
    const GetChequeInReport = () => {
        let url = config.url.BOC_URL + "inward-dashboard-data";
        let values = {
            "incharge_cfms_id": data?.data?.incharge_cfms_id,
            "inward_date_from": data?.fromDate,
            "inward_date_upto": data?.todate,  
        }
        return CommonAxiosPost(url, values).then((response) => {
            if (response.data.status === true) {
                setList(response?.data?.inward_dashboard_data?.filter((val)=>val.payment_status==="P"))
            }
            else {
                setList([])
            }
        })
    }
    const Formik = useFormik({
        enableReinitialize: false,
        initialValues:
        {
            bankSentDate: "",
            approverCfmsId: loginreducer?.username,
            inwardPayments: [
                {
                    "currentNo": "",
                    "paymentStatus": "",
                    "paymentDate": ""
                }
            ],
            paymentReceivedOnSameDay: "", //local
            isAllPaymentReceivedSuccess: "" //local

        },
        onSubmit: (values) => {
            let url = config.url.BOC_URL + "inward-payment-confirmation";//post final 
            CommonAxiosPost(url, values).then((res) => {
                if (res?.data?.scode === '01') {
                    Sweetalert("SuccessFully Saved", 'success')
                    GetChequeInReport()
                }
                else if (res.data.scode === '02') {
                    Sweetalert(res.data.sdesc, 'warning')
                }
            })
            console.log("values", JSON.stringify(values));
        },
        //validationSchema: InWardValidation
    })
    function paymentReceivedStatusFun(e) {
        for (var i = 0; i < showList?.length; i++) {
            Formik.setFieldValue(`inwardPayments[${i}].currentNo`, showList[i]?.current_no)
            Formik.setFieldValue(`inwardPayments[${i}].paymentStatus`, e.target.value)
        }
    }
    useEffect(() => {
        GetChequeInReport()
    }, [])
    return (
        <React.Fragment>
         <Header />
            <div className="main_section"> </div>
            <CommonPageHeading heading="Payment Confirmation" navigateData={data} path="/ApprovalPaymentReport" />
            <jnb.Container className="outer-page-content-container" >
        
            <FormikProvider value={Formik}>
                <jnb.Form onChange={Formik.handleChange} onSubmit={Formik.handleSubmit} className="form_adjust">
                    <jnb.Row className="pt-0 mt-2">
                       
                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                            <jnb.InputGroup className="">
                                <label>Bank Sent Date</label>
                            </jnb.InputGroup>
                            <Field type="date" className="form-control" name="bankSentDate" />
                            <ErrorMessage name="bankSentDate" component="div" className="text-error" />
                        </jnb.Col>
                        
                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                            <jnb.InputGroup className="">
                                <label>All payments received successfully</label>
                            </jnb.InputGroup>
                            <jnb.InputGroup className="form-control">
                                <Field type="radio" value="S" name="isAllPaymentReceivedSuccess"
                                    onChange={(e) => {
                                        paymentReceivedStatusFun(e)
                                    }} /> &nbsp; Success &nbsp;
                                <Field type="radio" value="F" name="isAllPaymentReceivedSuccess"
                                    onChange={(e) => {
                                        paymentReceivedStatusFun(e)
                                    }} />&nbsp; Failure
                            </jnb.InputGroup>
                            <ErrorMessage name="isAllPaymentReceivedSuccess" component="div" className="text-error" />

                        </jnb.Col>
                    </jnb.Row>

                    <div className="table-responsive" ref={ref}>
                        {/* <Afterprint /> */}
                        <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-1"
                            style={{ border: '2px solid lightblue', width: '100%', borderCollapse: 'collapse', }}
                        >
                            <thead >
                                <tr>
                                    <th>S.NO</th>
                                    <th>Current No.</th>
                                    <th>Organisation Name</th>
                                    <th>LR No. & Date</th>
                                    <th >Dept </th>
                                    <th >Work Executed at</th>
                                    <th>Date of Recieving</th>
                                    <th>By Dept / Extl</th>
                                    <th>Name of Bank</th>
                                    <th>Branch</th>
                                    <th>DD /Cheque</th>
                                    <th>cheque No. /DD No.</th>
                                    <th>Date</th>
                                    <th>Amount</th>
                                    <th>Payment status</th>
                                    <th>Payment Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {showList.map((item, index) => (
                                    <tr key={index}>
                                    
                                      
                                        <td>{index + 1} <input type="hidden" name={`inwardPayments[${index}.currentNo]`} value={item.current_no} /></td>
                                        <td>{item?.current_no}</td>
                                        <td>{item.organisation_name}</td>
                                        <td>{item.lr_no_and_date}</td>
                                        <td>{item.dept}</td>
                                        <td>
                                            {item.work_executed_at_district_name}
                                        </td>
                                        <td>{item.date_of_recieving}</td>
                                        <td>{item.by_dept}</td>
                                        <td>{item.name_of_bank}</td>
                                        <td>{item.branch}</td>
                                        <td>{item.dd_cheque}</td>
                                        <td>{item.cheque_no_or_ddno}</td>
                                        <td>{item.date}</td>
                                        <td>{item.amount}</td>

                                        <td style={{ textAlign: "center" }}>
                                            {item.payment_status === "Y" ? "Success" : item.payment_status === "N" ? "Fail" :
                                                <jnb.InputGroup className="form-group">
                                                    <Field type="radio" value="S" name={`inwardPayments[${index}.paymentStatus]`} />  S &nbsp;
                                                    <Field type="radio" value="F" name={`inwardPayments[${index}.paymentStatus]`} />&nbsp;F
                                                    <ErrorMessage name={`inwardPayments[${index}.paymentStatus]`} component="div" className="text-error" />
                                                </jnb.InputGroup>}</td>
                                        <td>
                                            {item.payment_date ? item.payment_date :
                                                <jnb.InputGroup className="">
                                                    <Field type="date" className="" name={`inwardPayments[${index}.paymentDate]`} />
                                                    <ErrorMessage name={`inwardPayments[${index}.paymentDate]`} component="div" className="text-error" />
                                                </jnb.InputGroup>
                                            }
                                        </td>


                                    </tr>
                                ))}

                            </tbody>


                        </table>

                    </div>
                    <div className='text-end mt-3'>
                        <ReactToPrint
                            content={() => ref.current}
                        >
                            <PrintContextConsumer>
                                {({ handlePrint }) => (
                                    <div className="text-center">
                                        <button type='button'
                                            className="btn btn-md btn-secondary"
                                            onClick={() => { handlePrint() }}
                                        >
                                            Print
                                        </button>
                                    </div>
                                )}
                            </PrintContextConsumer>
                        </ReactToPrint>

                        <div ref={ref} className='print-only-text'>
                            <ApprovalPrintPdf showList={showList} />
                        </div>

                        <button type="submit" className="btn btn-success btn-md">Submit Payment Receipt</button>
                    </div>

                </jnb.Form>
            </FormikProvider>
            </jnb.Container>

        </React.Fragment>
    )
}
